import React from 'react';
import logo from './logo.png';

const Logo = () => {
    return(
        <div className='f3'>
            <p style={{textAlign: 'left'}}><img src={logo} style={{width: '120px', height: 'auto', marginTop: '2%', marginLeft: '10%'}} /></p>
        </div>
    );
}

export default Logo;